import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getEdgeEvents, getEdgeEventsFilter } from "../../actions/Users/authenticateEdgeEvents";
import { getHighAvailabilityDevice, highAvailability } from "../../actions/Users/authenticateHighAvailability";
import { convertDateTimeIntoTimezone, getDecodeURI } from "../../utils/util";
import { useEffect, useRef, useState } from "react";
import { DEFAULT_PAGE_SIZE } from "../../constants/Constants";
import _ from "lodash";
import { RowPerPageHandler } from "../Pagination";
import { Button, Grid, InputAdornment, Paper, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import TabButtons from "../../UserScreen/InventoryPage/InventorySettings/components/TabButtons/TabButtons";
import NetworkTable, { ColumnType } from "../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable";
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import DownloadCSV, { clearCsvDownload } from "../DownloadCSV";
import Download from '../../asset/image/DownloadUsage.svg';
import { CREATE_HA, UPDATE_DEVICE, SYNC_DEVICE } from "../../actions/types";
import moment from "moment-timezone";

var Loader = require("react-loader");

const HA_COMPLETION_MARKERS = [
    'HA Auto sync completed',
    'HA Manual sync completed',
    'HA pair deleted',
    'HA pair update completed'
];

const MAX_POLL_COUNT = 30;

const ManageHALogs = (props) => {
    const { newSummaryStartDate, newSummaryEndDate, getEdgeEvents, getEdgeEventsFilter, getEdgeEventsData, getEdgeEventsFilterData, selectedVessel, location, history, setSelectedTab, selectedTab, getEdgeEventsLoading, getEdgeEventsFilterLoading, downloadAsCSV, csvDataDownloded, csvDownloadId, userTimezone, updateDeviceData, syncDeviceData, createDeviceData, deleteHA, getHighAvailabilityDevice, highAvailability, selectedOu} = props;

    const _q = getDecodeURI(location?.search);
    const DEFAULT_PAGE = 1;
    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState<string>(_q.hasOwnProperty("search") && _q.search.trim() !== '' ? _q.search : "");
    const [page, setPage] = useState<number>(_q.hasOwnProperty("page") && '' != _q.page.trim() ? parseInt(_q.page) : DEFAULT_PAGE);
    const [limit, setLimit] = useState<number>(_q.hasOwnProperty("limit") && '' != _q.limit.trim() ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [haLogsData, setHaLogsData] = useState<any[]>([]);
    const [sortBy, setSortBy] = useState<string>('ts');
    const [sortOrder, setSortOrder] = useState<string>('desc');
    const [filters, setFilters] = useState<any>({
        startTime: newSummaryStartDate,
        endTime: newSummaryEndDate,
        locationId: selectedVessel,
        pageSize: limit,
        offset: (page - 1) * limit,
        page: page,
        deviceIdFilter: "",
        moduleFilter: "",
        levelFilter: "",
        sourceFilter: "",
        searchValue: searchValue,
        sortBy: 'ts',
        sortOrder: 'desc'
    })
    const searchTimeoutRef = useRef<any>();
    const pollingRef = useRef<any>(null);
    const pollCountRef = useRef<number>(0);
    const pollingParamsRef = useRef<any>(null);
    const pollingStartTimeRef = useRef<number>(0);
    const pollingDurationRef = useRef<number>(0);
    const currentParamsRef = useRef<any>(null);
    const hasCheckedStorageRef = useRef(false);

    const buildFreshParams = () => {
        const freshEnd = moment().utc();
        const freshStart = moment(freshEnd).subtract(pollingDurationRef.current, 'ms');
        return { ...currentParamsRef.current, startTime: freshStart, endTime: freshEnd };
    };

    const stopPolling = () => {
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        pollCountRef.current = 0;
        localStorage.removeItem('ha_polling_state');
    };

    const startPolling = (params) => {
        stopPolling();
        pollingParamsRef.current = params;
        pollingDurationRef.current = moment(params.endTime).diff(moment(params.startTime));
        pollCountRef.current = 0;
        pollingStartTimeRef.current = Date.now();
        localStorage.setItem('ha_polling_state', JSON.stringify({ active: true, startedAt: pollingStartTimeRef.current }));
        const fresh = buildFreshParams();
        getEdgeEventsFilter(fresh);
        getEdgeEvents(fresh);
        pollingRef.current = setInterval(() => {
            pollCountRef.current += 1;
            if (pollingParamsRef.current) {
                const fp = buildFreshParams();
                getEdgeEventsFilter(fp);
                getEdgeEvents(fp);
                selectedVessel && selectedOu?.id && getHighAvailabilityDevice(selectedOu.id, selectedVessel);
                selectedVessel && highAvailability(selectedVessel);
            }
            if (pollCountRef.current >= MAX_POLL_COUNT) {
                window.dispatchEvent(new CustomEvent('ha_log_update', { detail: { maxReached: true } }));
                stopPolling();
            }
        }, 30000);
    };

    useEffect(() => {
        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        const handleHAAction = () => {
            if (currentParamsRef.current) {
                startPolling(currentParamsRef.current);
            }
        };
        window.addEventListener('ha_action_triggered', handleHAAction);
        return () => window.removeEventListener('ha_action_triggered', handleHAAction);
    }, []);

    // Resume polling after page refresh if an action was in progress
    useEffect(() => {
        if (!selectedVessel || hasCheckedStorageRef.current) return;
        hasCheckedStorageRef.current = true;
        const stored = JSON.parse(localStorage.getItem('ha_polling_state') || '{}');
        if (stored?.active && stored?.startedAt) {
            const elapsedMinutes = Math.floor((Date.now() - stored.startedAt) / 30000);
            if (elapsedMinutes < MAX_POLL_COUNT) {
                pollingStartTimeRef.current = stored.startedAt;
                const rangeDuration = moment(newSummaryEndDate).diff(moment(newSummaryStartDate));
                const freshEnd = moment().utc();
                const freshStart = moment(freshEnd).subtract(rangeDuration, 'ms');
                const resumeParams = {
                    startTime: freshStart,
                    endTime: freshEnd,
                    locationId: selectedVessel,
                    pageSize: limit,
                    offset: 0,
                    page: DEFAULT_PAGE,
                    deviceIdFilter: "",
                    moduleFilter: "and module IN ('HA')",
                    levelFilter: "",
                    search: "",
                    sourceFilter: "",
                    searchValue: "",
                    sort: 'ts',
                    order: 'desc'
                };
                pollingParamsRef.current = resumeParams;
                pollingDurationRef.current = moment(resumeParams.endTime).diff(moment(resumeParams.startTime));
                pollCountRef.current = elapsedMinutes;
                const resumeFresh = buildFreshParams();
                getEdgeEventsFilter(resumeFresh);
                getEdgeEvents(resumeFresh);
                pollingRef.current = setInterval(() => {
                    pollCountRef.current += 1;
                    if (pollingParamsRef.current) {
                        const fp = buildFreshParams();
                        getEdgeEventsFilter(fp);
                        getEdgeEvents(fp);
                        selectedVessel && selectedOu?.id && getHighAvailabilityDevice(selectedOu.id, selectedVessel);
                selectedVessel && highAvailability(selectedVessel);
                    }
                    if (pollCountRef.current >= MAX_POLL_COUNT) {
                        window.dispatchEvent(new CustomEvent('ha_log_update', { detail: { maxReached: true } }));
                        stopPolling();
                    }
                }, 30000);
            } else {
                localStorage.removeItem('ha_polling_state');
            }
        }
    }, [selectedVessel]);
    const [columns, setColumns] = useState<any>([
        {
            label: "Timestamp",
            key: "ts",
            type: ColumnType.text,
            maxWidth: "90px",
            formatDateAndTime: true,
            sortable: true
        },
        {
            label: "Device Id",
            key: "device_id",
            type: ColumnType.text,
            maxWidth: "100px",
            sortable: true
        },
        {
            label: "Device Name",
            key: "deviceAlias",
            type: ColumnType.text,
            maxWidth: "100px",
            sortable: true
        },
        {
            label: "Level",
            key: "level",
            type: ColumnType.text,
            maxWidth: "80px",
            sortable: true
        },
        {
            label: "Description",
            key: "description",
            type: ColumnType.text,
            maxWidth: "200px",
            sortable: true
        },
        {
            label: "Metadata",
            key: "metadata",
            type: ColumnType.metadata,
            maxWidth: "50px",
        },
    ])

    useEffect(() => {
        const rangeDuration = moment(newSummaryEndDate).diff(moment(newSummaryStartDate));
        const freshEnd = moment().utc();
        const freshStart = moment(freshEnd).subtract(rangeDuration, 'ms');
        let _limit = _q.hasOwnProperty("limit") ? _q.limit : filters.pageSize;
        let _page = _q.hasOwnProperty("page") ? _q.page : filters.page;
        let _searchValue = _q.hasOwnProperty("searchValue") ? _q.searchValue : filters.searchValue;

        let parameters = {
            startTime: freshStart,
            endTime: freshEnd,
            locationId: selectedVessel,
            pageSize: _limit,
            offset: (_page - 1) * _limit,
            page: _page,
            deviceIdFilter: "",
            moduleFilter: "",
            levelFilter: "",
            search: "",
            sourceFilter: "",
            searchValue: _searchValue,
            sort: filters.sortBy || 'ts',
            order: filters.sortOrder || 'desc'
        }

        parameters.moduleFilter = 'and module IN (\'HA\')';
        if (_searchValue) {
            parameters.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
          if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_searchValue}%' OR  b_metadata ILIKE '%${_searchValue}%')`
        }
        currentParamsRef.current = parameters;
        getEdgeEventsFilter(parameters);
        getEdgeEvents(parameters);
    }, [selectedVessel, newSummaryStartDate, newSummaryEndDate, filters])

    useEffect(() => {
        let _limit = _q.hasOwnProperty("limit") ? _q.limit : filters.pageSize;
        let _page = _q.hasOwnProperty("page") ? _q.page : filters.page;
        let _searchValue = _q.hasOwnProperty("searchValue") ? _q.searchValue : filters.searchValue;

        const rangeDuration = moment(newSummaryEndDate).diff(moment(newSummaryStartDate));
        const freshEnd = moment().utc();
        const freshStart = moment(freshEnd).subtract(rangeDuration, 'ms');

        let parameters = {
            startTime: freshStart,
            endTime: freshEnd,
            locationId: selectedVessel,
            pageSize: _limit,
            offset: (_page - 1) * _limit,
            page: _page,
            deviceIdFilter: "",
            moduleFilter: "",
            levelFilter: "",
            search: "",
            sourceFilter: "",
            searchValue: _searchValue,
            sort: filters.sortBy || 'ts',
            order: filters.sortOrder || 'desc'
        }

        parameters.moduleFilter = 'and module IN (\'HA\')';
        if (_searchValue) {
            parameters.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
          if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_searchValue}%' OR  b_metadata ILIKE '%${_searchValue}%')`
        }
        if(!_.isEmpty(updateDeviceData) || !_.isEmpty(createDeviceData) || !_.isEmpty(syncDeviceData) || !_.isEmpty(deleteHA)){
            getEdgeEventsFilter(parameters);
            getEdgeEvents(parameters);
        }
    },[updateDeviceData, syncDeviceData, createDeviceData, deleteHA]) 

    useEffect(() => {
        if (!_.isEmpty(getEdgeEventsData)) {
            const edgeEvents = getEdgeEventsData;
            if (edgeEvents) {
                const rows: any[] = edgeEvents?.data?.rows;
                const columns: string[] = edgeEvents?.data?.columns;
                const haLogsData: any[] = [];
                for (let i = 0; i < rows?.length; i++) {
                    const row = {};
                    const currentRow = rows[i];
                    columns.forEach((column, index) => {
                        row[column] = currentRow[index];
                    })
                    haLogsData.push(row);
                }
                setHaLogsData(haLogsData);
                if (pollingRef.current) {
                    const latestNewLog = haLogsData.find(row =>
                        new Date(row.ts).getTime() >= pollingStartTimeRef.current
                    );
                    if (latestNewLog?.description) {
                        const isComplete = HA_COMPLETION_MARKERS.some(m => latestNewLog.description?.includes(m));
                        window.dispatchEvent(new CustomEvent('ha_log_update', {
                            detail: { description: latestNewLog.description, isComplete }
                        }));
                        if (isComplete) {
                            selectedVessel && highAvailability(selectedVessel);
                            stopPolling();
                        }
                    }
                }
            }
        }
    }, [getEdgeEventsData]);

    useEffect(() => {
        if (!_.isEmpty(getEdgeEventsFilterData)) {
            const edgeEvents = getEdgeEventsFilterData?.data;
            if (edgeEvents && edgeEvents.hasOwnProperty('filters')) {
                const data = edgeEvents.filters.data;
                if (data.length >= 3) {
                    const totalRecords = Number.parseInt(data[4]);
                    let totalPages = Math.ceil(totalRecords / limit);
                    let fromIndex = (totalRecords > 0) ? (page * limit + 1) : 0;
                    let toIndex = (fromIndex + limit - 1) > totalRecords ? totalRecords : (fromIndex + limit - 1);
                    setTotalCount(totalRecords);
                } else {
                    setTotalCount(0);
                }
            }
        }
    }, [getEdgeEventsFilterData])

    const handlePageChange = (newPage, limit) => {
        setPage(newPage);
        setLimit(limit);
        setFilters({ ...filters, page: newPage, offset: (newPage - 1) * limit });
    };

    const handleChangeRowsPerPage: RowPerPageHandler = (limit) => {
        if (Number(limit)) {
            setPage(DEFAULT_PAGE)
            setLimit(Number(limit));
            setFilters({ ...filters, page: DEFAULT_PAGE, pageSize: limit, offset: (DEFAULT_PAGE - 1) * Number(limit) });
        }
    };

    const handleSearch = (value: string) => {
        setFilters({
            ...filters,
            searchValue: value,
            page: 1
        });
    };

    const handleOnSearchClick = () => {
        handleSearch(searchValue);
    }

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchValue(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            handleSearch(e.target.value);
        }, 1000)
    }

    const handleOnSearchClear = () => {
        setSearchValue('');
        handleSearch('');
    }

    const handleSorting = (key: string) => {
        const newOrder = sortBy === key ? (sortOrder === 'asc' ? 'desc' : 'asc') : 'asc';
        setSortBy(key);
        setSortOrder(newOrder);
        setFilters({ ...filters, sortBy: key, sortOrder: newOrder, page: DEFAULT_PAGE });
        setPage(DEFAULT_PAGE);
    };

    const handleDownloadReport = () => {
        const params: CsvParameters = {
            type: "QUERY_CH",
            id: "manage-config-HA-log-status",
            payload: {
                startTime: newSummaryStartDate,
                endTime: newSummaryEndDate,
                locationId: selectedVessel,
                pageSize: totalCount,
                offset: 0,
                page: 1,
                deviceIdFilter: "",
                moduleFilter: "and module IN ('HA')",
                levelFilter: "",
                sourceFilter: "",
                search: "",
                searchValue: searchValue ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
                   if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${searchValue}%' OR  b_metadata ILIKE '%${searchValue}%')` : '',
                sort: 'ts',
                order: 'desc'
            },
            queryName: "EDGE_EVENTS",
        };
        downloadAsCSV(params);
    }

    useEffect(() => {
        if (csvDataDownloded && csvDataDownloded.length > 0) {
            if (csvDownloadId === "manage-config-HA-log-status") {
                DownloadCSV(convertToCsv(csvDataDownloded, userTimezone),
                    {
                        formatters: {
                            0: 'ESC-COMMA',
                            2: 'ESC-COMMA',
                            4: 'ESC-COMMA',
                            5: 'ESC-COMMA',
                        }
                    }
                )
            }
            return () => {
                dispatch(clearCsvDownload());
            }
        }
    }, [csvDataDownloded]);

    const convertToCsv = (data: any[][], userTimezone: string) => {
        const [_columns, ...rows] = data;
        const csvRows: any[] = [];
        rows.forEach(row => {
            const timestamp = convertDateTimeIntoTimezone(row[0], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS);
            const metadata = JSON.stringify(JSON.parse(row[7]?.trim() || '{}')).replace(/"/g, '""').replace(/,/g, ';');
            csvRows.push([timestamp, row[2], row[8], row[3], row[5], metadata]);
        })
        return [['Timestamp', 'Device Id', 'Device Name', 'Level', 'Description', 'Metadata'], ...csvRows];
    }

    return (
        <Paper elevation={0} className="quota_management--dashboard manage-config-log-head">
            <div className="manageConfiglogHeadName" >Logs</div>
            <Grid classes={{ root: "quota_management--base--flew quota_management--base--flex--justify--end quota_management--base--padding_05x" }}>
                <Grid item xs={12} sm={12} md={12} lg={12} className='logs-table-search-container topbarWidth alignTopbarItemsCenter'>
                    <Grid item xs={4} sm={4} md={4} lg={4} className="searchbarBox searchbarMaxWidth1">
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            placeholder="Type something"
                            autoComplete="off"
                            value={searchValue}
                            onChange={handleOnSearchChange}
                            onKeyDown={(e) => { if (e.key === 'Enter') { handleOnSearchClick() } }}
                            size="small"
                            InputLabelProps={{ className: "serachLabel" }}
                            InputProps={{
                                className: "searchbarInputs",
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {!searchValue && <SearchIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClick}
                                        />}
                                        {searchValue && <CloseIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClear}
                                        />
                                        }
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} lg={2} ml={3}>
                        <TabButtons
                            options={['Device', 'HA']}
                            selected={selectedTab}
                            onChange={setSelectedTab}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} className="dwn-margin-auto">
                        {totalCount > 0 && haLogsData && haLogsData?.length !== 0 && <Grid item xs={6} sm={6} md={6} lg={6}>
                            <div className="download-summary-btn marg-left-auto" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button> </div>
                        </Grid>}
                        {getEdgeEventsLoading || getEdgeEventsFilterLoading ? (
                            <div className="config-logs-loader">
                                <Loader radius={4} length={5} lines={10} width={2} color={"#264C86"} />
                            </div>
                        ) : null}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className="TopUsersContainer">
                <NetworkTable
                    data={haLogsData}
                    columns={columns}
                    enablePagination={true}
                    rowsPerPageOptions={[10, 15, 25, 50, 100]}
                    defaultRowsPerPage={15}
                    headingHeight={40}
                    maxHeight={`calc(100vh - 450px)`}
                    totalRowCount={totalCount}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={limit}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    onSortChange={handleSorting}
                />
            </Grid>
        </Paper>
    );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    newSummaryStartDate: state?.authReducer?.newSummaryStartDate,
    newSummaryEndDate: state?.authReducer?.newSummaryEndDate,
    getEdgeEventsData: state?.authReducer?.getEdgeEvents,
    getEdgeEventsFilterData: state?.authReducer?.getEdgeEventsFilter,
    getEdgeEventsLoading: state?.authReducer?.getEdgeEventsLoading,
    getEdgeEventsFilterLoading: state?.authReducer?.getEdgeEventsFilterLoading,
    csvDataDownloded: state?.authReducer?.csvDataDownloded,
    csvDownloadId: state?.authReducer?.csvDownloadId,
    userTimezone: state?.authReducer?.userTimezone,
    updateDeviceData: state.authReducer?.updateDevice,
    syncDeviceData: state.authReducer?.syncDevice,
    createDeviceData: state.authReducer?.createHighAvailability,
    deleteHA: state.authReducer?.deleteHighAvailability,
    selectedOu: state?.authReducer?.selectedOu,
});
export default withRouter(
    connect(mapStateToProps, {
        getEdgeEvents,
        getEdgeEventsFilter,
        downloadAsCSV,
        getHighAvailabilityDevice,
        highAvailability
    })(ManageHALogs)
);